export const VIEW_ENTITY_TYPES = {
  QUOTES: 'quotes',
  QUOTE_ITEMS: 'quote_items',
} as const;

export const FILTER_CONDITIONS = {
  // select filter conditions
  IN: 'in',
  NOT_IN: 'ni',
  // datetime filter conditions
  ON: 'on',
  BEFORE: 'before',
  AFTER: 'after',
  RANGE: 'range',
  CURRENT: 'current',
  NEXT: 'next',
  PREVIOUS: 'previous',
  // metadata filter conditions
  EXACT: 'exact',
  NOT_EQUAL: 'ne',
  // numeric filter conditions
  EQUALS: 'equals',
  GREATER_THAN: 'gt',
  GREATER_THAN_OR_EQUAL: 'gte',
  LESS_THAN: 'lt',
  LESS_THAN_OR_EQUAL: 'lte',
} as const;

export const SELECT_FILTER_CONDITIONS = [
  FILTER_CONDITIONS.IN,
  FILTER_CONDITIONS.NOT_IN,
];
export const DATETIME_FILTER_CONDITIONS = [
  FILTER_CONDITIONS.ON,
  FILTER_CONDITIONS.BEFORE,
  FILTER_CONDITIONS.AFTER,
  FILTER_CONDITIONS.RANGE,
  FILTER_CONDITIONS.CURRENT,
  FILTER_CONDITIONS.NEXT,
  FILTER_CONDITIONS.PREVIOUS,
] as const;
export const METADATA_FILTER_CONDITIONS = [
  FILTER_CONDITIONS.EXACT,
  FILTER_CONDITIONS.NOT_EQUAL,
] as const;

export const NUMERIC_FILTER_CONDITIONS = [
  FILTER_CONDITIONS.EQUALS,
  FILTER_CONDITIONS.GREATER_THAN,
  FILTER_CONDITIONS.GREATER_THAN_OR_EQUAL,
  FILTER_CONDITIONS.LESS_THAN,
  FILTER_CONDITIONS.LESS_THAN_OR_EQUAL,
] as const;

export const SAVED_VIEW_REQUIRES_CREATED_DATE_ERROR =
  'saved_view_requires_created_date';
